module.exports = __webpack_public_path__ + "static/img/Bachelor_010301.13e6d3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010301.jpg
// module id = 144
// module chunks = 0